<div class="overlay-modal" (click)="onClickOverlay()"></div>
<div class="custom-modal" [ngStyle]="fixedSize?{width: '660px'}:{width: '80%'}">
  <a (click)="onClickClose()" class="modal-close"></a>
  <ng-content></ng-content>
</div>
